import { render, staticRenderFns } from "./NewTicketButton.vue?vue&type=template&id=de493f12&"
import script from "./NewTicketButton.vue?vue&type=script&lang=ts&"
export * from "./NewTicketButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports